const LEGACY_NULL_COMPANY_ID = 'null';

export function normalizeCompanyId(companyId: string | undefined): string | undefined {
  return companyId && companyId !== LEGACY_NULL_COMPANY_ID ? companyId : undefined;
}
